(function($){
  'use strict';

  if(!$.gnv){
    $.gnv = new Object();
  };

  $.gnv.mobileTotal = function(options){
    var base = this;
    base.opts = $.extend({},$.gnv.mobileTotal.defaultOptions, options);

    base.init = function(){

      base.resize();

      $(base.opts.mobileTotalPriceClass).click(function(e){
        e.preventDefault();

        $('html, body').animate({scrollTop: $(base.opts.mobileTotalTriggerClass).position().top}, 1000)

        $('.summary-booking-slider').slick('setPosition');

        $(window).trigger('resize');
      });

      $(window).scroll(base.scroll);
      $(window).resize(base.resize);
    };

    base.resize = function(){
      if($(window).width() < 1025){
        // On mobile: move summary to mobile total container
        $(base.opts.summaryId).appendTo($(base.opts.mobileTotalId)).addClass(base.opts.summaryMobileClass);
      } else {
        // On desktop: sticky positioning handled via CSS (position: sticky)
        $(base.opts.summaryId).removeClass(base.opts.summaryMobileClass).appendTo($(base.opts.sidebarId));
      }
      base.scroll();
    };

    base.scroll = function(options){
      if ( $(window).scrollTop() + $(window).height() > $(base.opts.mobileTotalTriggerClass).offset().top ) {
        $(base.opts.mobileTotalId).removeClass(base.opts.fixedClass);
        $('.b-mobile_seats_recap').removeClass(base.opts.fixedClass);
        $(base.opts.summaryId).addClass(base.opts.summaryMobileOpenedClass);
      } else {
        $(base.opts.mobileTotalId).addClass(base.opts.fixedClass);
        $('.b-mobile_seats_recap').addClass(base.opts.fixedClass);
        $(base.opts.summaryId).removeClass(base.opts.summaryMobileOpenedClass);
      }
    }

    base.init();
  };

  $.gnv.mobileTotal.defaultOptions = {
    mobileTotalId: '#js-mobile-total',
    mobileTotalPriceClass: '.b-mobile_total__price',
    sidebarId: '#js-sidebar-sticky',
    summaryId: '#js-summary-booking',
    summaryMobileClass: 'b-summary_booking--mobile',
    summaryMobileOpenedClass: 'b-summary_booking--mobile-opened',
    fixedClass: 'is-fixed-bottom',
    mobileTotalTriggerClass: '.b-mobile_total_trigger'
  };

  if($($.gnv.mobileTotal.defaultOptions.mobileTotalId).length)
    $.gnv.mobileTotal();

})(jQuery);



